import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useApiNotification} from "../../ui/ApiNotificationProvider";
import {removeProviderGuest} from "../../../api/pro-guest-functions";
import {GuestsBrowserSimple} from "../shared/guests/GuestsBrowserSimple";
import {ConfirmationPrompt} from "../../ui/ConfirmationPrompt";
import {GreyedOutProgressMask} from "../../ui/GreyedOutProgressMask";
import {run} from "../../../utils/function-util";
import {Guest} from "../../../models/pro-guest.models";
import {GuestsActions} from "../shared/guests/GuestsActions";

interface GuestListProps {
    organizationId: number;
}

const GuestList: React.FC<GuestListProps> = ({organizationId}) => {
    const {t} = useTranslation();
    const {handleError} = useApiNotification();
    const [refresh, setRefresh] = useState(0);
    const [userToDelete, setUserToDelete] = useState<Guest>();
    const [disableDelete, setDisableDelete] = useState(false);

    const removeGuest = async (user: Guest) => {
        setUserToDelete(user);
    };

    const deleteGuest = async () => {
        setDisableDelete(true);
    };

    useEffect(run(
        async () => {
            if (disableDelete && userToDelete) {
                const userId = userToDelete.id;
                setUserToDelete(undefined);
                return await removeProviderGuest(organizationId, userId)
            }
        },
        () => {
            if (disableDelete)
                setRefresh(r => r + 1);
        },
        handleError,
        () => setDisableDelete(false)
    ), [disableDelete]);

    const guestActions = (guest: Guest) => <GuestsActions organizationId={organizationId}
                                                          guest={guest}
                                                          onRemove={removeGuest}/>

    return (
        <GreyedOutProgressMask isActive={disableDelete} displaySpinner={true}>
            <GuestsBrowserSimple organizationId={organizationId}
                                 refresh={refresh}
                                 actionsRender={guestActions}
            />
            <ConfirmationPrompt
                title={t(`MyGuests.RemoveGuest.Title`)}
                description={t('MyGuests.RemoveGuest.Description')}
                open={!!userToDelete}
                disable={disableDelete}
                onCancel={() => setUserToDelete(undefined)}
                onConfirm={() => deleteGuest()}
            />
        </GreyedOutProgressMask>
    )
};

export default GuestList;
